import GroupedContentsTab from "./GroupedContentsTab";

export default function WaitTab({ list }) {
  return <GroupedContentsTab list={list} />;
}
